<template lang="pug">
    router-link.logo(to="/")
        div.logoContent
            img.mr-2(
                alt="Company Logo"
                :src="logoImage"
            )

            span.hidden-sm-and-down CleanDataSet, Inc.
</template>

<script>
    import logoImage from './images/logo-main-min.png';

    export default {
        data() {
            return {
                logoImage,
            };
        },
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl";

    .logo
        display: inline-block
        text-decoration: none

        img
            width: 50px

    .logoContent
        display: flex
        align-items: center
        font-size: 20px
        font-weight: 500
        text-decoration: none
        color: $theme.white

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .logo img
            width: 40px
</style>
